import React, { memo } from "react";
import { styledLabel } from "../CommonForm/CommonFormInterface";

const StyledLabel = ({
  field,
  extractedStyledLabel,
  classes,
  onClickStyledLabel,
}: {
  field: styledLabel;
  extractedStyledLabel: string;
  classes: string;
  onClickStyledLabel?: (e: React.MouseEvent<HTMLParagraphElement>) => void;
}) => {
  const LabelType = field.labelType ?? "p";
  return (
    extractedStyledLabel && (
      <LabelType
        className={`${field?.className ?? ""} ${
          field?.mapping?.className?.[classes] ?? ""
        }`}
        style={{
          ...(field?.style ?? {}),
          ...(field?.mapping?.style?.[classes] ?? {}),
        }}
        id={field?.id}
        {...(onClickStyledLabel ? { onClick: onClickStyledLabel } : {})}
      >
        {extractedStyledLabel}
      </LabelType>
    )
  );
};

export default memo(StyledLabel);
